export const SPEAKING_TOPICS = [
    {
        title: "Breaking the Cycles",
        tagline: "Signature keynote",
        description:
            "Healing generational patterns as a faith practice — naming what was passed down, grieving what it cost, and deciding what stops with you.",
    },
    {
        title: "Stop Shrinking, Start Rising",
        tagline: "Keynote · Conference",
        description:
            "A bold word for the woman playing small in rooms God called her to fill — trading fear dressed in scripture for holy confidence.",
    },
    {
        title: "The Holy 'No'",
        tagline: "Workshop · Retreat",
        description:
            "Recovery for the people-pleaser: boundaries, scripture, and soul-truth for the woman learning to live for an audience of One.",
    },
    {
        title: "Remember Your Worth",
        tagline: "Workshop · Ministry",
        description:
            "You don't earn your worth — you remember it. Rebuilding identity and self-worth on the rock of who God says you are.",
    },
    {
        title: "Becoming H.E.R. — Healed. Empowered. Restored.",
        tagline: "Signature keynote",
        description:
            "The heart of the podcast, live on your stage: an unfiltered testimony-driven journey from surviving to becoming.",
    },
    {
        title: "Unshakable Purpose",
        tagline: "Panel · Business",
        description:
            "Building a purpose-driven life and brand as a woman of faith — vision, consistency, and stewarding the assignment without abandoning yourself.",
    },
];
